var map = {
	"./calendar-w.svg": "a223",
	"./calendar.svg": "b8bd",
	"./contacts-w.svg": "d189",
	"./contacts.svg": "4c50",
	"./files-w.svg": "c62f",
	"./files.svg": "d38b",
	"./logo.svg": "5b1c",
	"./passwords-w.svg": "37cb",
	"./passwords.svg": "d681",
	"./slack.svg": "4c73",
	"./tasks-w.svg": "07a5",
	"./tasks.svg": "e882"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";